import React from 'react';
import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import { Field as AkField, FormFooter as AkFormFooter } from '@atlaskit/form';
import { useIntl } from '@atlassian/jira-intl';
import type { FormValues } from '../../../../../../../../../common/types';
import {
	getGoalValuesById,
	toEditableActionFieldName,
} from '../../../../../../../../../common/utils/goal/field/index.tsx';
import { validateGoal } from '../../../../../../../../../common/utils/goal/validators/index.tsx';
import messages from './messages';

type Props = {
	isDefaultGoal: boolean;
} & {
	id: string;
	loading: boolean;
	onSaveGoal: () => Promise<void>;
	onCancel: () => void;
};

const GoalActionsView = ({ id, loading, isDefaultGoal, onSaveGoal, onCancel }: Props) => {
	const fieldName = toEditableActionFieldName(id);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onValidate = (_: any, formData: FormValues) => {
		const { jqlQuery, duration } = getGoalValuesById(formData, id);
		return validateGoal(duration, jqlQuery, isDefaultGoal, formatMessage);
	};
	const { formatMessage } = useIntl();

	return (
		<AkField name={fieldName} defaultValue validate={onValidate}>
			{({ valid }) => (
				<AkFormFooter>
					<ButtonGroup>
						<LoadingButton
							appearance="primary"
							isDisabled={!valid}
							onClick={onSaveGoal}
							isLoading={loading}
							testId="servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.actions.save-button"
						>
							{formatMessage(messages.save)}
						</LoadingButton>
						<Button
							testId="servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.actions.cancel-button"
							onClick={onCancel}
						>
							{formatMessage(messages.cancel)}
						</Button>
					</ButtonGroup>
				</AkFormFooter>
			)}
		</AkField>
	);
};

export const GoalActions = GoalActionsView;
